export const isDropdownResetGuardEnabled = (): boolean => {
    const flagValue = (process.env.REACT_APP_ENABLE_DROPDOWN_RESET_GUARD || "").toLowerCase();

    if (!flagValue) {
        // Default on for safety unless explicitly disabled.
        return true;
    }

    return flagValue === "1" || flagValue === "true" || flagValue === "yes" || flagValue === "on";
};

export const resolveGuardedDependentId = (
    previousValue: string,
    isDependencySelected: boolean,
    fallbackValue: string
): string => {
    if (!isDropdownResetGuardEnabled()) {
        return fallbackValue;
    }

    return isDependencySelected ? previousValue : fallbackValue;
};
